import * as Icons from 'lucide-react';
import { propertyData } from '../mock';
import { useEffect, useRef } from 'react';

export const LocationSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll('.location-card');
            items.forEach((item, index) => {
              setTimeout(() => {
                item.classList.add('animate-in');
              }, index * 200);
            });
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="location" ref={sectionRef} className="py-24 bg-gradient-to-br from-amber-50 via-white to-yellow-50 relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute bottom-1/3 right-1/4 w-96 h-96 bg-gradient-to-br from-amber-400/15 to-yellow-500/15 rounded-full blur-3xl animate-float"></div>
        <div className="absolute top-1/4 left-1/4 w-80 h-80 bg-gradient-to-br from-yellow-400/15 to-amber-500/15 rounded-full blur-3xl animate-float-delayed"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <h2 className="text-5xl font-bold mb-16 text-center">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 via-yellow-600 to-amber-600 animate-shimmer">
              Location
            </span>
          </h2>
 <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9498.084892203278!2d78.305353!3d17.403841!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9568059411fd%3A0x80d6b41d599b7040!2sMSN%20REALTY!5e1!3m2!1sen!2sin!4v1769232222642!5m2!1sen!2sin" height="450" style={{ border: "0", width: "100%",marginBottom:'0.5rem' }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
          {/* Location Grid */}
          <div className="grid md:grid-cols-2 gap-8">
            {propertyData.locationDetails.sections.map((section, index) => {
              const IconComponent = Icons[section.icon] || Icons.MapPin;
              return (
                <div
                  key={index}
                  className="location-card luxury-card bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 opacity-0 translate-y-10 border-2 border-transparent hover:border-amber-300"
                >
                  {/* Icon and Title */}
                  <div className="flex items-center mb-6">
                    <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-yellow-600 rounded-full flex items-center justify-center mr-4 shadow-lg shadow-amber-500/30 transform hover:scale-110 hover:rotate-12 transition-all duration-500">
                      <IconComponent className="w-7 h-7 text-white" />
                    </div>
                    <h3 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-gray-900 to-amber-700">
                      {section.title}
                    </h3>
                  </div>

                  {/* Items List */}
                  <ul className="space-y-3">
                    {section.items.map((item, itemIndex) => (
                      <li
                        key={itemIndex}
                        className="text-gray-700 flex items-start group hover:translate-x-2 transition-transform duration-300"
                      >
                        <span className="text-amber-500 mr-3 font-bold group-hover:text-yellow-600 transition-colors duration-300">•</span>
                        <span className="group-hover:text-gray-900 transition-colors duration-300">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
         
        </div>
      </div>

      <style>{`
        .location-card.animate-in {
          opacity: 1;
          transform: translateY(0);
          transition: opacity 0.8s ease-out, transform 0.8s ease-out;
        }
      `}</style>
    </section>
  );
};
